import {forwardRef} from 'react';
import type {ReportType} from '../../../../../../core/entities/reportAnalytics/schema';
import {convertStringToReportType} from '../../../../../../core/factories/reports/convertStringToReportType';
import {ReportTypeLabel} from '../../../../../reports/components/Container/Presenter/ReportTypeLabel';

export type SelectItemProps = {
  label: string;
  value: string;
  reportType?: ReportType;
  departmentName?: string;
} & React.ComponentPropsWithoutRef<'div'>;

/**
 * 部門選択のSelectアイテムコンポーネント
 * 体験記タイプバッジと部門名を表示する
 */
export const DepartmentSelectItem = forwardRef<HTMLDivElement, SelectItemProps>(
  ({label, departmentName, reportType, ...others}, ref) => (
    <div
      ref={ref}
      {...others}
      className="flex text-base items-center gap-8 p-8 data-[hovered=true]:bg-background-1"
    >
      {reportType && (
        <ReportTypeLabel type={convertStringToReportType(reportType)} />
      )}
      <span className="flex-1">{departmentName ?? label}</span>
    </div>
  ),
);

DepartmentSelectItem.displayName = 'DepartmentSelectItem';
